function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.571 8.889C.571 9.5 1.086 10 1.714 10h4.572c.628 0 1.143-.5 1.143-1.111V2.222H.57V8.89zM8 .556H6L5.429 0H2.57L2 .556H0v1.11h8V.557z",
  fill: "currentColor"
});

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 10",
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "64164d88a53d55f75c4ce55806fa76c2.svg";
export { SvgTrash as ReactComponent };